<template>
    <v-layout column :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-4': $vuetify.breakpoint.smAndUp}">
        <v-layout v-if="content.author" row wrap
                  justify-space-between
                  align-center
        >
            <v-flex class="ideas-item__user" :class="{'mt-2 pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}">
                <div class="ideas-item__user-avatar">
                    <img :src="content.author.avatar" alt="avatar" width="40px"
                         height="40px"
                    >
                </div>
                <v-layout column align-start>
                    <router-link class="link--anchor" :to="{name: 'profile_other', params: {id: content.author.id}}"><span>{{ content.author.name }}</span></router-link>
                    <v-layout align-center>
                        <img :src="content.author.chevron" alt="chevron" class="mt-1"
                             width="30px" height="25px"
                        >
                        <div class="grey-text">{{ content.author.rank }}</div>
                    </v-layout>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm5>
                <v-layout text-sm-right :class="{'justify-end': $vuetify.breakpoint.smAndUp}">
                    <div class="mr-2">{{ day(content.date) }}</div>
                    <div class="grey-text">{{ time(content.date) }}</div>
                </v-layout>
            </v-flex>
        </v-layout>
        <div class="mt-2 mb-3">{{ content.text }}</div>
        <linkIcon v-if="content.author.id == user.id" icon="edit" size="20"
                  @click.native="open_edit_modal(content.id)"
        >{{ $t("Редактировать") }}</linkIcon>
        <!-- <linkRed v-if="user.role == 'admin'">{{ $t("Удалить") }}</linkRed> -->
        <!-- <linkRed v-else @click.native="open_delete_modal(content.id)">{{ $t("Удалить") }}</linkRed> -->
    </v-layout>
</template>

<script>
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import linkRed from '@/components/ui/links/styled/link_red';
import ideaEditCommentModal from './Ideas_bank_modals/Ideas_edit_comment_modal';
import dayjs from 'dayjs';
import {mapGetters, mapMutations} from 'vuex';
export default {
  components: {
    linkIcon,
    linkRed,
    ideaEditCommentModal,
  },
  props: {
    content: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('ideas_bank', [
      'edit_comment_modal',
    ]),
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapMutations('ideas_bank/comments', [
      'SET_EDITED_ID',
    ]),
    day(date) {
      return new dayjs(date).format('DD.MM.YYYY');
    },
    time(date) {
      return new dayjs(date).format('HH.mm');
    },
    open_edit_modal(id) {
      this.OPEN_MODAL('edit_comment_modal');
      this.SET_EDITED_ID(id);
    },
    open_delete_modal(id) {
      this.OPEN_MODAL('delete_comment_modal');
      this.SET_EDITED_ID(id);
    },
  },

};
</script>
